// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { adjustInventory } from "./schema/adjust-inventory";
import { exportAdjustmentHistory } from "./schema/adjustment-history/export-adjustment-history";
import { listAdjustmentHistory } from "./schema/adjustment-history/list-adjustment-history";
import { cancelAdjustmentSession } from "./schema/adjustment-session/cancel-adjustment-session";
import { createAdjustmentSession } from "./schema/adjustment-session/create-adjustment-session";
import { getAdjustmentSession } from "./schema/adjustment-session/get-adjustment-session";
import { listAdjustmentSessions } from "./schema/adjustment-session/list-adjustment-sessions";
import { submitAdjustmentSession } from "./schema/adjustment-session/submit-adjustment-session";
import { updateAdjustmentSession } from "./schema/adjustment-session/update-adjustment-session";
import { createBillOfMaterials } from "./schema/bill-of-materials/create-bill-of-materials";
import { deleteBillOfMaterials } from "./schema/bill-of-materials/delete-bill-of-materials";
import { deleteBillOfMaterialsLocation } from "./schema/bill-of-materials/delete-bill-of-materials-location";
import { getBillOfMaterials } from "./schema/bill-of-materials/get-bill-of-materials";
import { getBillOfMaterialsByOutputProducts } from "./schema/bill-of-materials/get-bill-of-materials-by-output-products";
import { getBillOfMaterialsList } from "./schema/bill-of-materials/get-bill-of-materials-list";
import { getBillOfMaterialsLocations } from "./schema/bill-of-materials/get-bill-of-materials-locations";
import { getBillOfMaterialsTags } from "./schema/bill-of-materials/get-bill-of-materials-tags";
import { searchBillOfMaterials } from "./schema/bill-of-materials/search-bill-of-materials";
import { updateBillOfMaterials } from "./schema/bill-of-materials/update-bill-of-materials";
import { updateBillOfMaterialsLocation } from "./schema/bill-of-materials/update-bill-of-materials-location";
import { createAttributeDefinition } from "./schema/create-attribute-definition";
import { deleteAttributeDefinition } from "./schema/delete-attribute-definition";
import { listAttributeDefinitions } from "./schema/list-attribute-definitions";
import { updateAttributeDefinition } from "./schema/update-attribute-definition";

export const groupA = {
  adjustInventory,
  cancelAdjustmentSession,
  createAdjustmentSession,
  getAdjustmentSession,
  listAdjustmentSessions,
  submitAdjustmentSession,
  updateAdjustmentSession,
  exportAdjustmentHistory,
  listAdjustmentHistory,
  createAttributeDefinition,
  deleteAttributeDefinition,
  listAttributeDefinitions,
  updateAttributeDefinition,
  createBillOfMaterials,
  deleteBillOfMaterials,
  deleteBillOfMaterialsLocation,
  getBillOfMaterials,
  getBillOfMaterialsByOutputProducts,
  getBillOfMaterialsList,
  getBillOfMaterialsLocations,
  getBillOfMaterialsTags,
  searchBillOfMaterials,
  updateBillOfMaterials,
  updateBillOfMaterialsLocation,
};
